// extracted by mini-css-extract-plugin
export var container = "Hero-module--container--z2i3F";
export var inner = "Hero-module--inner--9s68f";
export var subtitle = "Hero-module--subtitle--DQicd";
export var designers = "Hero-module--designers---7yLB";
export var brandImage = "Hero-module--brandImage--h9l1-";
export var form = "Hero-module--form--cJunM";
export var col = "Hero-module--col--dJ5Vu";